const initialState = {
	list: [],
	page: 1,
	isListNext: false,
	datetime: null,
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case 'MAIL_TRASH_LIST_SET': {
			let newState = Object.assign({}, state);
			newState.list = action.payload.list;
			newState.page = action.payload.page;
			newState.isListNext = action.payload.isListNext;
			newState.datetime = (new Date());
			return newState;
		}
		case 'MAIL_TRASH_LIST_DATETIME_INIT': {
			let newState = Object.assign({}, state);
			newState.datetime = null;
			return newState;
		}
		case 'MAIL_TRASH_ITEM_SET': {
			let newState = Object.assign({}, state);
			let index = newState.list.findIndex((v) => v.pic === action.payload.pic);
			if (index >= 0) {
				if (action.payload.type === 'del') {
					newState.list.splice( index, 1 );
				}
			}
			return newState;
		}
		default: {
			return state;
		}
	}
}
